var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgUpArrowCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 92,
    viewBox: "0 0 98 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_35233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.9875 6.135C80.9653 4.96075 78.4573 4.60452 75.6604 5.19824C73.9402 5.56767 72.1018 6.28013 70.1846 7.3884C68.3594 8.4439 66.5998 9.78966 64.9453 11.3333L74.3735 16.8351C76.028 15.2915 77.7876 13.9589 79.6128 12.8902C81.5169 11.7819 83.3552 11.0563 85.0885 10.7C87.8855 10.1063 90.3935 10.4494 92.4157 11.6368L82.9875 6.135Z",
    fill: "#C9D4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1281 1.41164C56.7908 0.0394867 53.8888 -0.356326 50.6585 0.329749C48.6626 0.751949 46.5353 1.58315 44.3424 2.86295C40.6788 4.98714 37.2384 8.08767 34.2577 11.7423C28.7557 18.4843 24.8032 27.1394 23.8446 35.1876C22.1901 35.5702 20.4305 36.2695 18.6053 37.325C15.4407 39.1589 12.473 41.8241 9.89932 44.9774C4.3711 51.7194 0.641844 60.7043 0.668107 68.515C0.681238 74.2147 2.69031 78.2124 5.90745 80.0991L15.3356 85.6009C12.1054 83.7142 10.1094 79.7033 10.0963 74.0168C10.07 66.2061 13.7993 57.2212 19.3144 50.4792C21.8881 47.3259 24.8557 44.6607 28.0203 42.8268C29.8324 41.7713 31.592 41.072 33.2597 40.6894C34.2183 32.6412 38.1707 23.9861 43.6727 17.2441C46.6535 13.5895 50.0939 10.5021 53.7575 8.36474C55.9635 7.08495 58.0907 6.25374 60.0736 5.83154C63.3038 5.14547 66.2058 5.55447 68.5432 6.91343L59.115 1.41164H59.1281Z",
    fill: "#C9D4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7706 8.36494C64.1836 2.32221 72.8502 6.16159 74.3865 16.8353C76.0411 15.2917 77.8007 13.9591 79.6259 12.8904C89.5531 7.12473 97.6287 11.7557 97.6681 23.2211C97.6944 34.6865 89.6712 48.6586 79.7441 54.4111L28.1517 84.3477C18.2245 90.1134 10.1488 85.4824 10.1094 74.017C10.0832 62.5517 18.1063 48.5795 28.0335 42.827C29.8456 41.7715 31.6183 41.0722 33.2728 40.6896C34.7567 28.2743 43.3576 14.4077 53.7837 8.36494H53.7706Z",
    fill: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8876 91.9998L47.2695 87.4612V73.9904L54.6361 72.2224L53.8876 91.9998Z",
    fill: "#E08609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4621 44.8455L78.1145 59.2134L46.3633 77.6715L62.4621 44.8455Z",
    fill: "#FAC003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8916 62.6965V81.4053L53.8867 91.9998V70.4545L70.8916 62.6965Z",
    fill: "#FAC003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4619 44.8454L56.1458 40.7686L40.1914 73.7397L46.3631 77.6715L62.4619 44.8454Z",
    fill: "#E08609"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_35233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 92,
    fill: "white",
    transform: "translate(0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUpArrowCloud);
export default __webpack_public_path__ + "static/media/img-up-arrow-cloud.48266a4b86f12ca0d97c7f08152918d9.svg";
export { ForwardRef as ReactComponent };